module.exports = __webpack_public_path__ + "img/risklatte_logo.59ec54f3.png";